import { BuildType } from './ApiService';

export type DemoSkillSource = 'extraction' | 'search' | 'manual' | 'custom';

export interface DemoAdminPreviewItem {
    id: string;
    name: string;
    source: DemoSkillSource;
    addedAt?: string;
}

export interface DemoAdminPreview {
    windowHours: number;
    skills: DemoAdminPreviewItem[];
}

export interface DemoAdminResult {
    userSkillsDeleted: number;
    customSkillsDeleted: number;
    documentsDeleted: number;
}

export const demoAdminService = (build: BuildType) => ({
    previewDemoAdmin: build.query<DemoAdminPreview, void>({
        query: () => 'demo-admin/skills/preview',
        providesTags: ['UserSkills', 'UserCustomSkills'],
    }),
    resetDemoSkills: build.mutation<DemoAdminResult, void>({
        query: () => ({
            url: 'demo-admin/skills/reset',
            method: 'POST',
        }),
        invalidatesTags: ['UserSkills', 'UserCustomSkills'],
    }),
    clearExtractionJob: build.mutation<{ cleared: boolean }, void>({
        query: () => ({
            url: 'demo-admin/skills/infer/clear',
            method: 'POST',
        }),
        invalidatesTags: ['SkillInferenceUpload'],
    }),
});
